import Newsletter from "@components/Newsletter/Newsletter";
import Sectioncomminity from "@components/frontpage/section_comminity";
import BaseLayout from "@layout/base-layout";
import { observer } from "mobx-react";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { NextSeo } from "next-seo";
import { useTranslation } from "react-i18next";

const DataProtection = observer((props) => {
  const { t } = useTranslation("common");
  const canonicalUrl = `${process.env.NEXT_PUBLIC_SITE_ADDRESS}data-protection`;

  return (
    <>
      <NextSeo
        title={t("tag.protection_meta_title")}
        description={t("tag.protection_meta_description")}
        canonical={canonicalUrl}
        openGraph={{
          url: canonicalUrl,
          title: `${t("tag.protection_meta_title")}`,
          description: `${t("tag.protection_meta_description")}`,
          site_name: "Moverii",
        }}
        twitter={{
          handle: "@handle",
          site: "@site",
          cardType: "summary_large_image",
        }}
      />
      <main className="container">
        <div className="mx-auto mt-10 flex w-full flex-col items-start justify-center">
          <article className="flex w-full flex-col items-start justify-center">
            <h1 className="m-0 text-4xl font-bold ">
              {t("Data_Protection.Data_Protection")}
            </h1>
            <p className="mt-7 text-base font-normal ">
              {t("Data_Protection.we_appreciate_your_visit_to_our_website")}
            </p>
            <p className="text-base font-normal mt-3">
              {t("Data_Protection.we_only_collect_process_and_use_personal")}
            </p>
            <p className="text-base font-normal mt-3">
              {t("Data_Protection.for_data_processing_we_have_implemented")}
            </p>
          </article>
          <article className="mt-12 flex w-full flex-col items-start justify-center">
            <h2 className="m-0 text-2xl font-bold ">
              <span className="text-orange">1. </span>
              {t("Data_Protection.responsible_party")}
            </h2>
            <p className="mt-7 text-base font-normal ">
              {t("Data_Protection.the_responsible_party_within_the_meaning")}
            </p>
            <ul className="text-base font-normal  mt-5">
              <li>moverii GmbH</li>
              <li>Daniel Helbig</li>
              <li> {t("Data_Protection.Castle_Street")} </li>
              <li>53115 Bonn</li>
              <li> {t("Data_Protection.Germany")} </li>
            </ul>
            <ul className="text-base font-normal mt-5 ">
              {/* <li>{t("Data_Protection.telephone_01633122260")} </li> */}
              <li>{t("Data_Protection.whatsapp_number")}: +491632220021</li>
              <li>{t("Data_Protection.email")}: team@moverii.de</li>
              <li>Website: www.moverii.de</li>
            </ul>
            <p className="text-base font-normal mt-5">
              {t("Data_Protection.questions_or_comments_about_this")}
            </p>
          </article>
          <article className="mt-12 flex w-full flex-col items-start justify-center">
            <h2 className="m-0 text-2xl font-bold ">
              <span className="text-orange">2. </span>
              {t("Data_Protection.access_data_in_server_logfiles")}
            </h2>
            <div className={"space-y-5"}>
              <p className="mt-7 text-base font-normal ">
                {t("Data_Protection.the_use_of_our_website_is_generally")}
              </p>
              <p className="text-base font-normal ">
                {t(
                  "Data_Protection.this_data_cannot_be_assigned_to_specific_persons"
                )}
              </p>
            </div>
          </article>
          <article className="mt-12 flex w-full flex-col items-start justify-center">
            <h2 className="m-0 text-2xl font-bold ">
              <span className="text-orange">3. </span>{" "}
              {t("Data_Protection.collection_and_use_of_personal_data")}
            </h2>
            <div className={"space-y-5"}>
              <p className="mt-7 text-base font-normal ">
                {t(
                  "Data_Protection.during_registration_as_a_user_of_the_platform"
                )}
              </p>
              <p className="text-base font-normal ">
                {t("Data_Protection.when_you_register_on_our_website_your_ip")}
              </p>
              <p className="text-base font-normal ">
                {t(
                  "Data_Protection.we_use_the_data_you_provide_for_registration_and"
                )}
              </p>
              <p className="text-base font-normal ">
                {t(
                  "Data_Protection.we_provide_any_person_at_any_time_upon_request"
                )}
              </p>
            </div>
          </article>

          <div className="!text-white !bg-white">
            <script
              id="CookieDeclaration"
              src="https://consent.cookiebot.com/f856e30a-8b38-4afb-a08c-6ed96a4a1df5/cd.js"
              type="text/javascript"
              async
            ></script>
          </div>

          {/* Newsletter 3 image */}
          <Newsletter
            image1={"/static/images/news.png"}
            image2={
              process.env.NEXT_PUBLIC_IMAGE_ADDRESS +
              "cdn/statics/Newsletter-Element/Aktivurlaub_moverii.jpg"
            }
            image3={
              process.env.NEXT_PUBLIC_IMAGE_ADDRESS +
              "cdn/statics/Newsletter-Element/Yoga-Retreats_moverii.jpg"
            }
            title={t("contact.newsletter_title")}
            description={t("contact.newsletter_description")}
            inputPlaceholder={t("contact.newsletter_placeholder")}
            buttonTitle={t("contact.newsletter_button")}
          />
          {/* End of Newsletter 3 image */}
          <section className={"container mx-auto mb-10"}>
            <Sectioncomminity mode={"white"} />
          </section>
        </div>
      </main>
    </>
  );
});
DataProtection.Layout = BaseLayout;
export const getServerSideProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
    },
  };
};
export default DataProtection;
